/**
 * Pagination Factory
 *
 * Contains general properties and methods related to lazy load data from the server to increase
 * single page application performances.
 *
 * This factory is meant to be a class, other factories should create instances out of it.
 */
HuesMdl.factory( 'PaginationFcty', ['$http', '$q', function ( $http, $q ) {

	var HANDLERS = {
		API_URL: '',
		limit: 0,
		offset: 0,
		results: false,
		no_results: false,
		last_page: false
	};

	function Pagination(config) {
		angular.extend(this, HANDLERS, config);
	}

	Pagination.prototype = {
		constructor: Pagination,

		getResults: function() {
			var self = this,
				deffered = $q.defer();

			if( this.no_results || this.last_page ) {
				deffered.reject('no results');
				return deffered.promise;
			}

			$http.get( this.API_URL + '/limit/' + this.limit + '/offset/' + this.offset ).then(
				function ( response ) {
					if( response.data.length ) {
						self.results = self.results ? self.results : [];
						self.results = response.data;
						self.offset = self.offset + self.limit;


						if ( response.data.length < self.limit )
							self.last_page = true;

						deffered.resolve( self.results );
					}
					else {
						self.no_results = true;
						deffered.reject();
					}
				},
				function( error ) {
					deffered.reject(error);
				}
			);
			return deffered.promise;
		},

		resetHandlers: function() {
			this.results = false;
			this.offset = 0;
			this.API_URL = '';
			this.no_results =  false;
			this.last_page = false;
		}
	};

	return Pagination;
}]);